import './toggle-panel-section.css';
import h from 'hyperscript';
import { Switch } from 'ui/switch/switch';

const NAME = 'd-toggle-panel-section';

// TODO_NOW (lott, 2020-01-25, varGIS) add hint styling and sub-section functionality when used for the first time. Also extend example in catalog accordingly.
export class TogglePanelSection extends HTMLElement {

  #body;
  #switch;

  constructor (label, checked, onToggle) {
    super();
    const heading = h('h1.d-panel-section--heading', label);
    if (checked !== null && checked !== undefined && onToggle !== null && onToggle !== undefined) {
      this.#switch = this._createToggleSwitch(checked, onToggle);
      this.#switch.classList.add('toggle-panel-section--heading-switch');
      heading.append(h('.d-panel-section--buttons',
        this.#switch
      ));
    }
    this.append(heading);
  }

  connectedCallback () {
    this.classList.add('d-panel-section');
    this.classList.add(NAME);
  }

  setHint (hint) {
    const oldHint = this.#body.querySelector('.d-toggle-panel-section--hint');
    if (oldHint) {
      oldHint.remove();
    }
    this.#body.insertAdjacentElement('afterbegin', h('.d-toggle-panel-section--hint', hint));
  }

  addSubDescription (label) {
    this.append(h('.d-panel-section--description', label));
  }

  addSubToggle (label, checked, onToggle, className) {
    const subToggle = h('span.d-panel-section--subtoggle', [ this._createToggleSwitch(checked, onToggle), label ]);
    subToggle.classList.add(className);
    this.append(subToggle);
    return subToggle;
  }

  set checked (value) {
    this.#switch.checked = value;
  }

  get checked () {
    return this.#switch.checked;
  }

  setSubToggleChecked (value, className) {
    this.querySelector(`.${className} d-switch`).checked = value;
  }

  _createToggleSwitch (checked, onToggle) {
    const toggleSwitch = new Switch();
    toggleSwitch.checked = checked;
    toggleSwitch.addEventListener('change', onToggle);
    return toggleSwitch;
  }

}

customElements.define(NAME, TogglePanelSection);
